import { Dictionary } from '@ngrx/entity';
import { FieldState, FilterOptionDefinition, OptionState } from '../../models';
import { FieldIndex, ItemData, OptionIndex } from './create-filter-index.function';
import { createOptionState } from './create-option-state.function';

export function handleOptionWithCustomMatcher(
  fieldIndex: FieldIndex,
  fieldState: FieldState,
  optionWithCustomMatcher: FilterOptionDefinition<any>,
  dataDictionary: Dictionary<any>
): OptionState {
  if (!fieldIndex) {
    return;
  }

  const optionIndex: OptionIndex = { dataIds: {} };

  Object.values(fieldState.options).forEach((optionState) => {
    const currentOptionIndex: OptionIndex = fieldIndex.optionsIndex[optionState.id];

    Object.keys(optionState.relatedDataInfo).forEach((relatedDataId) => {
      const dataIdsMapping: ItemData = currentOptionIndex.dataIds[relatedDataId];
      if (!dataIdsMapping) {
        return;
      }
      if (
        optionWithCustomMatcher.customMatcher(
          dataDictionary[relatedDataId],
          optionState.value,
          Object.values(dataIdsMapping.nestedData)
        )
      ) {
        const dataIdsMapping: ItemData = optionIndex.dataIds[relatedDataId];

        if (!dataIdsMapping) {
          optionIndex.dataIds[relatedDataId] = {
            nestedData: {},
          };
        }

        Object.keys(currentOptionIndex.dataIds).forEach((id) => {
          if (!optionIndex.dataIds[id]?.nestedData) {
            optionIndex.dataIds[id] = {
              nestedData: {},
            };
          }

          optionIndex.dataIds[id].nestedData = {
            ...optionIndex.dataIds[id].nestedData,
            ...currentOptionIndex.dataIds[id].nestedData,
          };
        });
      }
    });
  });

  return createOptionState(fieldState, optionWithCustomMatcher, optionIndex);
}
